module.exports = __webpack_public_path__ + "static/media/keyboard-fade3.ce647376.png";